<template>
    <div class="content-wrapper book_submission">
        <!-- Page Loader -->
        <div class="vld-parent">
            <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        </div>

        <breadcrumb :page="$t('form.book.editBookSubmission')"></breadcrumb>

        <div class="content">
            <div class="container-fluid">
                <back-button/>

                <!-- <b-alert v-model="disableEditForm" variant="info">{{disableEditFormMessage}}</b-alert> -->

                

                <b-modal v-model="bookConfirm"  hide-header hide-footer>
                    <p class="my-4 text-center">{{$t('form.book.add_stock_back_confirm')}}</p>
                    <div class="text-center">
                    <b-button class="d-inline" variant="primary" inline 
                    @click="incrementBookStock('yes')">Yes</b-button>
                    <b-button class="d-inline" variant="secondary" inline @click="incrementBookStock('no')">No</b-button>
                    </div>
                   
                </b-modal>

                 <b-modal v-model="bundleConfirm"  hide-header hide-footer>
                    <p class="my-4 text-center">{{$t('form.book.add_stock_back_confirm')}}</p>
                    <div class="text-center">
                    <b-button class="d-inline" variant="primary" inline @click="incrementBundleStock('yes')">Yes</b-button>
                    <b-button class="d-inline" variant="secondary" inline @click="incrementBundleStock('no')">No</b-button>
                    </div>
                </b-modal>

                <b-alert v-model="showDisableAlert"  variant="info"> {{disableEditFormMessage}}
                    <button v-if="!firstLoad && sessionCreated" @click="checkForEdit(true)">
                         <i class="fas fa-sync"></i>
                    </button>
                </b-alert>

                <b-alert v-model="alert" :variant="alertClass" dismissible fade>{{alertMessage}}</b-alert>

                <div class="card">
                    <div class="card-header bg-light">
                        <div class="card-title">{{$t('form.book.editBookSubmission')}}</div>

                        <div class="text-right">
                            <button class="btn btn-primary" @click="submission()"
                                :disabled="disableEditForm">{{$t('button.update')}}</button>
                            <button class="btn btn-info" @click="submission(true)"
                                :disabled="disableEditForm">{{$t('button.updateClose')}}</button>
                            <button class="btn btn-info" @click="goToShow(student.ID)">
                            <i class="fas fa-list"></i></button>
                        </div>

                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="StudentField">{{$t('form.book.studentName')}}<span
                                            class="text-danger">*</span></label>
                                    <input id="StudentField" v-model.trim="$v.student.Name.$model"
                                        :placeholder="$t('form.book.searchStudent')" type="text"
                                        @keyup="searchStudent()" class="form-control"
                                        :class="{ 'is-invalid': $v.student.Name.$error }">
                                    <div class="invalid-feedback" v-if="!$v.student.Name.required">
                                        {{$t('form.validation.required')}}</div>
                                    <ul class="list-group m-0">
                                        <li class="list-group-item" v-for="(std,index) in students" v-bind:key='index'
                                            @click="selectedStudent(std)">
                                            <a style="cursor:pointer">{{std.FirstName}} {{std.LastName}}</a>
                                        </li>
                                    </ul>
                                </div>

                                <div class="form-group">
                                    <label for="NumberField">{{$t('form.book.studentNumber')}}</label>
                                    <input id="NumberField" type="text" class="form-control"
                                        v-model="student.StudentNumber" disabled>
                                </div>

                                <div class="form-group">
                                    <label for="BirthDateField">{{$t('form.book.birthDate')}}</label>
                                    <input id="BirthDateField" type="text" v-model="student.BirthDate"
                                        class="form-control" disabled>
                                </div>

                                <div class="form-group">
                                    <label for="BirthPlaceField">{{$t('form.book.birthPlace')}}</label>
                                    <input id="BirthPlaceField" v-model="student.BirthPlace" type="text"
                                        class="form-control" disabled>
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="table-responsive">
                                    <table class="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th>{{$t('form.book.bookBundle')}}</th>
                                                <th>{{$t('form.book.print')}}</th>
                                                <th class="text-right">
                                                    <input type="button" class="btn btn-sm btn-primary"
                                                        @click="addBookBundle()" :value="$t('button.addBundle')">
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(bb,index) in selectedBookBundles" v-bind:key="index">
                                                <td>
                                                    <v-select label="Description" :options="bookBundles" v-model="bb.ID"
                                                        :reduce="bookBundles => bookBundles.ID">
                                                    </v-select>
                                                </td>

                                                <td>
                                                    <input type="checkbox" v-model="bb.Print">
                                                </td>

                                                <td class="text-right">
                                                    <button class="btn btn-danger btn-sm"
                                                        @click="showBundleConfirm(index, bb)">
                                                        <i class="fa fa-times"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-sm-12">
                                <div class="table-responsive">
                                    <table class="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th>{{$t('form.book.book')}}</th>
                                                <th>{{$t('form.book.dateReceived')}}</th>
                                                <th class="text-right">
                                                    <input type="button" class="btn btn-primary btn-sm"
                                                        @click="addBook()" :value="$t('button.addBook')">
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(b,index) in selectedBooks" v-bind:key="index">
                                                <td>
                                                    <v-select label="Label" :options="books" v-model="b.ID"
                                                        :reduce="books => books.ID">
                                                    </v-select>
                                                </td>
                                                <td>
                                                    <input type="date" v-model="b.TakingDate" class="form-control">
                                                </td>
                                                <td class="text-right">
                                                    <button class="btn btn-danger btn-sm" @click="showBookConfirm(index, b)">
                                                        <i class="fa fa-times"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import {
        required,
    } from "vuelidate/lib/validators";

    export default {
        props: ['permissions', 'editFormInterval', 'dateFormat'],

        data() {
            return {
                alert: false,
                bookConfirm:false,
                bundleConfirm:false,
                increment:false,
                index:null,
                file:null,
                alertClass: '',
                alertMessage: '',

                isLoading: false,
                fullPage: true,

                request_source: '',
                interval: '',
                disableEditFormMessage: '',
                disableEditForm: false,
                closing: true,


                showDisableAlert: false,
                firstLoad:true,
                sessionCreated:true,
                continueInterVal:true,


                student: {
                    StudentNumber: null,
                    BirthPlace: null,
                    BirthDate: null,
                    Name: null,
                    ID: null,
                },

                selectedBooks: [],
                removedBooks:[],
                savedBooks:[],
                selectedBookBundles: [],
                removedBundles:[],
                savedBundles:[],
                students: [],
                books: [],
                bookBundles: []
            }
        },

        validations: {
            student: {
                Name: {
                    required
                }
            }
        },

        mounted() {
            if (!this.permissions.editBooksSubmissions) {
                this.$router.push('/');
                return;
            }

            this.checkForEdit();
            let self = this;

            this.interval = setInterval(() => {
                    if(self.continueInterVal)
                    self.checkForEdit();
                    }, this.editFormInterval);


            this.getBooks();
            this.getBookBundles();
            this.getSubmission();
        },

        watch: {
            student: {
                handler(val) {
                    this.closing = false;
                },
                deep: true
            },
            selectedBooks: {
                handler(val) {
                    this.closing = false;
                },
                deep: true
            },
            selectedBookBundles: {
                handler(val) {
                    this.closing = false;
                },
                deep: true
            }
        },

        methods: {

            goToShow(id) {
                this.$router.push({
                    name: "BookSubmittedShow",

                    params: {
                        id: id
                    }
                });
            },
            searchStudent() {

                if (this.student.Name == '') {
                    this.clear();
                    return;
                }

                let source = axios.CancelToken.source();

                if (this.request_source != '')
                    this.request_source.cancel('Operation canceled by the user.');

                this.request_source = source;

                axios
                    .get(`/api/students?name=${this.student.Name}`, {
                        cancelToken: this.request_source.token
                    })
                    .then(res => this.students = res.data.data.data)
                    .catch(error => console.log('error'));
            },

            selectedStudent(std) {
                this.student.StudentNumber = std.StudentNumber;
                this.student.BirthPlace = std.BirthPlace;
                this.student.BirthDate = this.$options.filters.formatDate(std.BirthDate, this.dateFormat);
                this.student.Name = std.FirstName + " " + std.LastName;
                this.student.ID = std.ID;

                this.clear();
            },

            clear() {
                this.students = [];
            },

            getBooks() {
                axios
                    .get('/api/books?full')
                    .then(response => {
                         this.books = response.data.map(function (book){
                            return {ID:book.ID, Label: book.Title + ' - ' + book.Edition}
                        });                        
                        })
                    .catch(error => console.log('error'));
            },

            addBook() {
                this.selectedBooks.push({
                    ID: null,
                    TakingDate: moment().format('YYYY-MM-DD')
                });
              
            },
            showBookConfirm(index, file=null){
                this.bookConfirm = true;
                this.index = index;
                this.file = file;
            },
            incrementBookStock(inc){
                if(inc === 'yes'){
                    this.increment = true;
                }else{
                    this.increment = false;
                }
                this.bookConfirm = false;
                this.removeBook();

            },
            removeBook() {
                
                if(this.file){
                    if(this.savedBooks.find(x => x.ID === this.file.ID)){
                     this.removedBooks.push({ID:this.file.ID, increment:this.increment});
                    }
                }

                this.selectedBooks.splice(this.index, 1);
                this.increment = false;
                this.file = null;
                this.index = null;

            },

            getBookBundles() {
                axios
                    .get('/api/bookbundles?full')
                    .then(response => {
                        this.bookBundles = response.data;
                    })
                    .catch(error => console.log('error'));
            },

            addBookBundle() {
                this.selectedBookBundles.push({
                    ID: null,
                    Print: null,
                });
            },

            showBundleConfirm(index, file=null){
                this.bundleConfirm = true;
                this.index = index;
                this.file = file;

            },
            incrementBundleStock(inc){
                if(inc === 'yes'){
                    this.increment = true;
                }else{
                    this.increment = false;
                }
                this.bundleConfirm = false;
                this.removeBookBundle();
            },
            removeBookBundle() {
              
                 this.showConfirm = true;
                                
                if(this.file){
                    if(this.savedBundles.find(x => x.ID === this.file.ID)){
                        
                        this.removedBundles.push({ID:this.file.ID, increment:this.increment});

                    };

                    this.selectedBookBundles.splice(this.index, 1);
                    this.increment = false;
                    this.file = null;
                    this.index = null;

                }

               
               
            },

            submission(shouldClose = false) {

                this.$v.$touch();

                if (this.disableEditForm) return;

                if (this.$v.$invalid) {
                    this.showAlert(this.$t('form.validation.error'), 'danger');
                    return;
                }
                
                function getUniqueList(list){
                    return new Set(list);
                } 


                let newBooks = [];
                let newBundles = [];

                const savedBooks = this.savedBooks;
                const savedBundles = this.savedBundles;

                const remove_books = [];
                const remove_bundles = [];
                const add_books = [];
                const add_bundles = [];
              


                /* Avoid duplication */
                this.selectedBooks = Array.from(getUniqueList(this.selectedBooks));
                this.selectedBookBundles = Array.from(getUniqueList(this.selectedBookBundles));
                this.removedBooks = Array.from(getUniqueList(this.removedBooks));
                this.removedBundles = Array.from(getUniqueList(this.removedBundles));


                /* Avoid updating books already saved in the database*/
                newBooks =  this.selectedBooks.filter(function(objFromA) {
                    return !savedBooks.find(function(objFromB) {
                        return objFromA.ID === objFromB.ID
                        })
                });

               
                /* Remove books removed and readded*/           
               this.removedBooks = this.removedBooks.filter(function(objFromA) {
                    return !newBooks.find(function(objFromB) {
                        return objFromA.ID === objFromB.ID
                        })
                }); 

                newBooks.forEach(b => add_books.push(JSON.stringify(b)));
                this.removedBooks.forEach(rb => remove_books.push(JSON.stringify(rb)));
                
                
                
                /* Avoid updating bundles already saved in the database*/
                newBundles =  this.selectedBookBundles.filter(function(objFromA) {
                    return !savedBundles.find(function(objFromB) {
                        return objFromA.ID === objFromB.ID
                        })
                });

                /* Avoid bundles removed and readded*/           
               this.removedBundles = this.removedBundles.filter(function(objFromA) {
                    return !newBundles.find(function(objFromB) {
                        return objFromA.ID === objFromB.ID
                        })
                }); 
                
                newBundles.forEach(bb => add_bundles.push(JSON.stringify(bb)));
                this.removedBundles.forEach(rbb => remove_bundles.push(JSON.stringify(rbb)));


                const data = {
                    student: this.student,
                    add_books,
                    add_bundles,
                    remove_books,
                    remove_bundles
                };

                this.isLoading = true;

                axios
                    .put('/api/submissions/' + this.student.ID, data)
                    .then(response => {
                        this.isLoading = false;
                        this.closing = true;

                        if (response.data.error) {
                            this.showAlert(response.data.message, 'danger');
                        } else if (response.data.error_book) {
                            this.showAlert(response.data.message, 'danger');
                        } else if (response.data.success) {
                            this.showAlert(response.data.message);

                              if (shouldClose) {
                                    clearInterval(this.interval);
                                    setTimeout(() => this.$router.go(-1), 2000);
                                    return;
                                }

                            /* Update to avoid duplication*/
                            this.removedBooks = [];
                            this.removedBundles = [];
                          
                        }
                    })
                    .catch(error => {
                        this.isLoading = false;
                        console.log('error');
                    });
            },

            getSubmission() {
                this.isLoading = true;

                axios
                    .get(`/api/submissions/${this.$route.params.id}/edit`)
                    .then(response => {
                        let data = response.data;

                        this.selectedBooks = [];
                        this.selectedBookBundles = [];

                        this.student.Name = data.student.FirstName + ' ' + data.student.LastName;
                        this.student.ID = data.student.ID;
                        this.student.BirthDate = this.$options.filters.formatDate(data.student.BirthDate, this
                            .dateFormat)
                        this.student.BirthPlace = data.student.BirthPlace;
                        this.student.StudentNumber = data.student.StudentNumber;

                        data.books.forEach(b => {
                            this.selectedBooks.push({
                                ID: b.BookID,
                                TakingDate: b.TakingDate,
                            });
                        });

                        data.books.forEach(b => {
                            this.savedBooks.push({
                                ID: b.BookID,
                                TakingDate: b.TakingDate,
                            });
                        });


                        data.bookbundles.forEach(bb => {
                            this.selectedBookBundles.push({
                                ID: bb.BookBundleID,
                                Print: bb.Print
                            });
                        });

                        data.bookbundles.forEach(bb => {
                            this.savedBundles.push({
                                ID: bb.BookBundleID,
                                Print: bb.Print
                            });
                        });
                        


                        setTimeout(() => {
                            this.isLoading = false;
                            this.closing = true;
                        }, 3000);
                    })
                    .catch(error => {
                        this.isLoading = false;
                        console.log('error');
                    });
            },



            checkForEdit(refresh = false)
            {

                    if(refresh)
                    this.continueInterVal = true;
                    let data= {
                        'field_id':this.$route.params.id,
                        'form':this.$route.name,
                        'refresh':refresh,
                    }
                    // if(refresh) this.showDisableAlert = false;
                    axios
                    .post("/api/check-for-edit-session" , data)
                    .then(response => {

                        this.sessionCreated = true;
                        if (response.data.warning == 0) {

                            this.disableEditForm = false;
                            this.showDisableAlert = false;
                            if(this.firstLoad)
                            {
                                this.firstLoad = false;
                                this.getBooks();
                                this.getBookBundles();
                                this.getSubmission();
                            }
                        }

                        if (response.data.warning == -1) {
                            this.disableEditForm = false ;
                            this.showDisableAlert = false;
                        }

                        if (response.data.warning == 1) {
                             this.firstLoad = false;
                            this.disableEditFormMessage = response.data.message;
                            this.disableEditForm = true;
                            this.showDisableAlert = true;
                            this.continueInterVal = false;
                        }

                        if (response.data.warning == 2) {
                            let msg = response.data.message;
                            if(this.firstLoad){
                              msg.replace('re-open' ,'open');
                            }
                            this.sessionCreated = false;
                            this.disableEditFormMessage = msg;
                            this.disableEditForm = true;
                            this.showDisableAlert = true;
                        }
                        if (response.data.warning == 3) {
                            this.disableEditForm = false;
                            this.showDisableAlert = true;
                            this.disableEditFormMessage = response.data.message;
                        }
                    })
                    .catch(error => {
                        console.log('error');
                    })
                },



            checkForEdit() {
                axios
                    .get("/api/check-for-edit/" + this.$route.params.id + "/submission")
                    .then(response => {
                        if (response.data.warning == 0) {
                            this.getBooks();
                            this.getBookBundles();
                            this.getSubmission();
                            this.disableEditForm = false;
                        }

                        if (response.data.warning == 1) {
                            this.disableEditFormMessage = response.data.message;
                            this.disableEditForm = true;
                            clearInterval(this.interval);
                        }

                        if (response.data.warning == 2) {
                            this.disableEditFormMessage = response.data.message;
                            this.disableEditForm = true;
                        }

                    })
                    .catch(error => {
                        console.log(error.response);
                    })
            },

            showAlert(msg, cls = 'success') {
                this.alertMessage = msg;
                this.alertClass = cls;
                this.alert = true;
            }
        },

        beforeRouteLeave(to, from, next) {
            if (this.closing) next()
            else {
                const answer = window.confirm(this.$t('leavePrompt'))

                if (answer) {
                    next()
                } else {
                    next(false)
                }
            }
        }
    }

</script>
<style scoped>
    .searchCourseBackground:hover {
        background: #eee;
    }

    .book_submission .v-select ul.vs__dropdown-menu {
        position: relative !important;
    }

</style>
